import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { updateMinutes } from 'Redux/Payment/payment.actions'
import PropTypes from 'prop-types'
import { NotificationContainer } from 'react-notifications'
import { Toaster } from 'react-hot-toast'
import toast from 'react-hot-toast'
import 'react-notifications/lib/notifications.css'
import './App.css'
import { useHistory, Route, Switch, Redirect } from 'react-router-dom'
import { PrivateRoute } from './Utils/private-route'

const Login = React.lazy(() => import('./Containers/Login'))
const Auth = React.lazy(() => import('./Containers/Auth'))
const Payment = React.lazy(() => import('./Containers/Payment'))
const SuccessPage = React.lazy(() => import('./Components/SuccessPage'))

function App() {
  const history = useHistory()

  useEffect(() => {
    // Only start timer if we are not on the login page
    if (!window.location.pathname.includes('/login')) {
      const interval = setInterval(() => {
        // Halt timer if user is in the middle of a payment
        if (localStorage.getItem('onPayment') === 'true') {
          return
        }

        const m = localStorage.getItem('minute')
        const p = parseInt(m) || 0

        if (p >= 15) {
          toast.error('The connection has timed out. Please Try Again!', {
            duration: 7000,
          })

          // Reset the minute count to prevent immediate re-triggering
          localStorage.setItem('minute', '0')

          setTimeout(() => {
            // Using history.push for SPA navigation to ensure components
            // unmount properly, which can help dismiss browser-native UIs.
            history.push('/login')
          }, 3000)
        } else {
          localStorage.setItem('minute', (p + 1).toString())
        }
      }, 60000)

      return () => clearInterval(interval)
    }
  }, [history])

  useEffect(() => {
    const path = window.location.pathname
    const url = window.location.href.split('/').pop()
    const [pin, apptId] = url.split('&appt=')
    if (
      path.includes('.well-known') ||
      pin === 'login' ||
      pin === 'sms' ||
      pin === 'payment-success' ||
      pin === 'payment'
    ) {
      return
    }
    sessionStorage.setItem('pin', pin)
    apptId
      ? sessionStorage.setItem('apptId', apptId)
      : sessionStorage.removeItem('apptId')
    history.push('/login')
  }, [])

  return (
    <>
      <React.Suspense fallback={''}>
        <Switch>
          <PrivateRoute permission={true} path="/payment" component={Payment} />
          <PrivateRoute
            permission={true}
            path="/payment-success"
            component={SuccessPage}
          />
          <Route path="/login" component={Login} />
          <Route path="/sms" component={Auth} />
        </Switch>
      </React.Suspense>

      <Toaster />
      <NotificationContainer />
    </>
  )
}

const mapStateToProps = (state) => ({
  LoginData: state.login,
})

const mapDispatchToProps = (dispatch) => ({
  updateMinutes: (values) => dispatch(updateMinutes(values)),
})
App.propTypes = {
  updateMinutes: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps)(App)
